import React, { Component } from 'react'
import Unauthorized from '../../components/unauthorized'

class UnauthorizedPage extends Component {

  render() {

    const {
      translate,
    } = this.props

    return (
      <Unauthorized translate={translate} />
    )
  }

}


export default UnauthorizedPage;
